export const carStatus = {
  0: '休息',
  1: '空車',
  2: '派遣中',
  3: '載客中',
  4: '排班中',
  5: '登出',
  6: '失聯',
  7: '停權',
}



// WEBPACK FOOTER //
// ./src/constants/car.js